module.exports = __webpack_public_path__ + "media/images/pic/popup/popup-mobile-bg-5fa9262bcfbca2437ea9c030dae86749.jpg";